import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M15.78 6.22a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0l-3.5-3.503a.75.75 0 0 1 1.06-1.06l2.97 2.972 6.47-6.47a.75.75 0 0 1 1.06 0Z" }) }), l = s.forwardRef(a);
export {
  l as F
};
//# sourceMappingURL=Check20.CqJjuR__.js.map
